import React, {Component} from 'react'
import {TimelineMax, TweenMax, Power2} from 'gsap'


import Background from '../common/Background'
import servicesBG from '../../assets/images/services/services-bg.jpg'


// Import services images

import event from '../../assets/images/services/event-management.jpg'
import brand from '../../assets/images/services/brand-activation.jpg'
import planning from '../../assets/images/services/planning.jpg'
import innovation from '../../assets/images/services/innovation.jpg'

class Services extends Component {

    componentDidMount() {


        if (window.innerWidth > 768) {
            // setting Objects
            const image = document.getElementsByClassName('image-holder')
            const small_heading = document.getElementsByClassName('small')
            const heading_part_one = document.getElementsByClassName('part1')
            const heading_part_two = document.getElementsByClassName('part2')
            const description = document.getElementsByClassName('page-description')

            // Defining Timeline
            let timeline = new TimelineMax()

            // setter
            timeline.set(image, {scale: 1, opacity: 0})
            timeline.set(small_heading, {opacity: 0, x: '-50'})
            timeline.set(heading_part_one, {opacity: 0, x: '-50'})
            timeline.set(heading_part_two, {opacity: 0, x: '-50'})
            timeline.set(description, {opacity: 0, x: '-50'})

            // Animation
            timeline.to(image, 1.5,
                {
                    scale: 1,
                    opacity: 1,
                    force3D: false,
                    ease: Power2.easeOut
                })
                .to(small_heading, 1.5,
                    {
                        opacity: 1,
                        x: '0',
                        force3D: false,
                        ease: Power2.easeOut
                    }, '-=1.2')
                .to(heading_part_one, 1.5,
                    {
                        opacity: 1,
                        x: '0',
                        force3D: false,
                        ease: Power2.easeOut
                    }, '-=1.2')
                .to(heading_part_two, 1.5,
                    {
                        opacity: 1,
                        x: '0',
                        force3D: false,
                        ease: Power2.easeOut
                    }, '-=1.2')
                .to(description, 1.5,
                    {
                        opacity: 1,
                        x: '0',
                        force3D: false,
                        ease: Power2.easeOut
                    }, '-=1.2')


            //    Services Images
            const imgTint = document.getElementsByClassName('tint')
            const imgEvent = document.getElementById('event')
            const imgBrand = document.getElementById('brand')
            const imgPlanning = document.getElementById('planning')
            const imgInnovation = document.getElementById('innovation')


            const btnEvent = document.getElementById('eventManagement')
            const btnBrand = document.getElementById('brandActivation')
            const btnPlanning = document.getElementById('plannings')
            const btnInnovation = document.getElementById('innovations')

            TweenMax.set(imgTint, {opacity: 0})
            TweenMax.set(imgEvent, {opacity: 0})
            TweenMax.set(imgBrand, {opacity: 0})
            TweenMax.set(imgPlanning, {opacity: 0})
            TweenMax.set(imgInnovation, {opacity: 0})

            function tintIn(e) {
                TweenMax.to(e, .7, {opacity: 1})
            }

            function tintOut(e) {
                TweenMax.to(e, .7, {opacity: 0})
            }

            btnEvent.onmouseover = function () {
                TweenMax.to(imgEvent, .7, {opacity: 1})
                tintIn(imgTint)
                tintOut(btnBrand)
                tintOut(btnPlanning)
                tintOut(btnInnovation)

            }
            btnEvent.onmouseout = function () {
                TweenMax.to(imgEvent, .7, {opacity: 0})

                tintOut(imgTint)
                tintIn(btnBrand)
                tintIn(btnPlanning)
                tintIn(btnInnovation)
            }


            btnBrand.onmouseover = function () {
                TweenMax.to(imgBrand, .7, {opacity: 1})
                tintIn(imgTint)
                tintOut(btnEvent)
                tintOut(btnPlanning)
                tintOut(btnInnovation)
            }
            btnBrand.onmouseout = function () {
                TweenMax.to(imgBrand, .7, {opacity: 0})
                tintOut(imgTint)
                tintIn(btnEvent)
                tintIn(btnPlanning)
                tintIn(btnInnovation)
            }


            btnPlanning.onmouseover = function () {
                TweenMax.to(imgPlanning, .7, {opacity: 1})
                tintIn(imgTint)
                tintOut(btnEvent)
                tintOut(btnBrand)
                tintOut(btnInnovation)
            }
            btnPlanning.onmouseout = function () {
                TweenMax.to(imgPlanning, .7, {opacity: 0})
                tintOut(imgTint)
                tintIn(btnEvent)
                tintIn(btnBrand)
                tintIn(btnInnovation)
            }


            btnInnovation.onmouseover = function () {
                TweenMax.to(imgInnovation, .7, {opacity: 1})
                tintIn(imgTint)
                tintOut(btnEvent)
                tintOut(btnBrand)
                tintOut(btnPlanning)
            }
            btnInnovation.onmouseout = function () {
                TweenMax.to(imgInnovation, .7, {opacity: 0})
                tintOut(imgTint)
                tintIn(btnEvent)
                tintIn(btnBrand)
                tintIn(btnPlanning)
            }

        }
    }






    render() {
        return (

                <div id="services">
                    <div className="image-holder">
                        <Background src={servicesBG}/>
                    </div>
                    <div className="heading">
                        <small className="small">Services We offer</small>
                        <h1>
                            <span className="part1">Let’s Craft</span>
                            <span className="part2">Difference Together</span>
                        </h1>
                        <p className="page-description">
                            We believe in providing complete customer satisfaction to our clients through our efficient
                            media planning & buying, Brand activation and event management services.
                        </p>
                    </div>
                    <div className="content">
                        <div className="sub-heading">
                            <h2>
                                OUR CORE COMPETENCIES
                            </h2>
                            <p>Strategic placement, competitive rates & outstanding customer care services
                                <br/> –all under one roof!</p>
                        </div>

                        <div className="services-holder">
                            <div className="service" id="eventManagement">
                                <div className="digit">01</div>
                                <div className="title"><span>EVENT</span> MANAGEMENT</div>
                                <p>
                                    Just like it is extremely important to craft an effective advertising message to
                                    attract
                                    customers, choosing the right platform to convey your message is equally
                                    significant.
                                </p>
                            </div>

                            <div className="service" id="brandActivation">
                                <div className="digit">02</div>
                                <div className="title"><span>BRAND</span> ACTIVATION</div>
                                <p>
                                    Hart Communications Private Limited also specializes in event planning and
                                    management
                                    services. We conceptualize, plan, produce and execute a variety of events. </p>
                            </div>

                            <div className="service" id="plannings">
                                <div className="digit">03</div>
                                <div className="title"><span>PLANNING</span> & BUYING</div>
                                <p>
                                    Hart Communications Pvt. Ltd also focuses on providing BTL advertising solution to
                                    its
                                    clients. In order to obtain the desired outcome, a wide-ranging array of services is
                                    offered by the company </p>
                            </div>

                            <div className="service" id="innovations">
                                <div className="digit">04</div>
                                <div className="title"><span>INNOVATIVE</span> SOLUTIONS</div>
                                <p>
                                    Our team of highly creative and passionate individuals work in sync with our clients to provide them with a number of innovative ideas/solutions, leaving a lasting impact on all and sundry.
                                    Keeping a keen eye on the types of advertisement happening all around the world, we try to bring something new and attractive from time to time. We believe that 'more different the display, the more eye balls it will get'. Having an experienced in-house team with international exposure and an enthusiastic consideration of how important innovation is in out-of-home advertising, we put our heart and soul for our client's campaign to have the effect that even exceeds their own expectations.

                                </p>
                            </div>
                        </div>


                        <div className="features-holder">
                            <div className="row">
                                <div className="feature">
                                    <h3>Strategic placement</h3>
                                    <p>We disseminate your message to the right people, at the right time and in the
                                        right
                                        place. </p>
                                </div>

                                <div className="feature">
                                    <h3>Great value for your investment</h3>
                                    <p>We ascertain to put you in a powerful position and assure that you get your
                                        return on
                                        investment in the best possible manner.</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="feature">
                                    <h3>Ad tracking/ campaign tracking service</h3>
                                    <p>We provide a timely and well-run ad tracking/ campaign tracking which helps to
                                        assess
                                        the success of the outdoor media campaign. </p>
                                </div>

                                <div className="feature">
                                    <h3>Dedicated client services</h3>
                                    <p>We make sure to take care of all our clients' needs and respond to their concerns
                                        at
                                        our earliest. </p>
                                </div>
                            </div>


                        </div>

                    </div>


                    <div className="images-holder">
                        <div className="tint"></div>
                        <img src={event} alt="Event Management" id="event"/>
                        <img src={brand} alt="brand activation" id="brand"/>
                        <img src={planning} alt="Planning and Buying" id="innovation"/>
                        <img src={innovation} alt="Innovation" id="planning"/>
                    </div>

                </div>

        )
    }
}

export default Services



// WEBPACK FOOTER //
// ./src/components/Pages/Services.js